import React from "react";
import { Link } from "react-router-dom";

export type ProductActionVariant = "primary" | "secondary";

type ProductActionButtonProps = {
  label: string;
  href?: string;
  external?: boolean;
  variant?: ProductActionVariant;
  onClick?: (event: React.MouseEvent) => void;
};

const baseClass =
  "inline-flex items-center justify-center px-6 py-2.5 rounded-full text-[11px] uppercase tracking-[0.18em] font-semibold cursor-pointer transition-colors duration-300";

const variantClass: Record<ProductActionVariant, string> = {
  primary:
    "bg-white text-black hover:bg-white/85",
  secondary:
    "bg-transparent text-white border-2 border-white hover:bg-white hover:text-black",
};

const ProductActionButton: React.FC<ProductActionButtonProps> = ({
  label,
  href,
  external = true,
  variant = "secondary",
  onClick,
}) => {
  const className = `${baseClass} ${variantClass[variant]}`;
  const isPlaceholder = !href || href === "#";
  const isInternal = !isPlaceholder && (external === false || href.startsWith("/"));

  if (isPlaceholder) {
    return (
      <span className={`${className} opacity-50 cursor-not-allowed`}>
        {label}
      </span>
    );
  }

  if (isInternal) {
    return (
      <Link to={href} onClick={onClick} className={className}>
        {label}
      </Link>
    );
  }

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      onClick={onClick}
      className={className}
    >
      {label}
    </a>
  );
};

export default ProductActionButton;
